export default "/assets/images/basic-breather2.png?626944010b33b33f725fc0a33d8c4753";